import firebase from "firebase";
import store from '@/store'
import router from '@/router'

class helpers {

    get_api_endpoint(endpoint, params) {

        let api_endpoint = '' ;
        // let api_endpoint = 'https://api.crowdsite.com/v1' ;
        //let api_endpoint = 'http://0.0.0.0:8086/v1' ;
        // let api_endpoint = 'http://192.168.2.6:8086/v1' ;

        // console.log('teste');
        // console.log(process.env.NODE_ENV);
        // process.env.NODE_ENV === 'development'

        if(process.env.NODE_ENV === 'development'){
            api_endpoint = 'http://localhost:8086/v1' ;
        }else{
            api_endpoint = 'https://api.realtime.report/v1' ;
        }

        if(params){
            return api_endpoint+endpoint+"?a="+params ;
        }

        return api_endpoint+endpoint ;        

    }

    get_lang(langArray, vuetifyLang) {

        let default_locale = 'nl' ;
        let locale = vuetifyLang.current ;

        if(!langArray){
            return '' ; 
        }

        if(langArray[locale]){
            return langArray[locale] ; 
        }

        if(langArray[default_locale]){
            return langArray[default_locale] ; 
        }

        return '' ; 

    }

    get_money(price) {

        /**
         *
         * price_notation
         * int, eu, int_after, eu_after
         */

        if (price) {

            return "€"+price+",-" ;

            // let valuta = state.administration.meta.currency;
            // let price_notation = state.administration.meta.price_notation;
            // let valutaSymbol = state.currency[valuta];

            // if (price % 1 != 0) {
            //     let commaIndex = 0;

            //     if (price_notation == "eu" || price_notation == "eu_after") {
            //         price = price.toString().replace(".", ",");
            //         commaIndex = price.indexOf(",") + 1;
            //     } else {
            //         commaIndex = price.indexOf(".") + 1;
            //     }

            //     let stringLength = price.length;

            //     if (stringLength - commaIndex == 1) {
            //         price += "0";
            //     }

            //     if (price_notation == "int" || price_notation == "eu") {
            //         return valutaSymbol + " " + price;
            //     }
            //     return price + " " + valutaSymbol;
            // } else {
            //     if (price_notation == "int" || price_notation == "eu") {
            //         return valutaSymbol + price + ",- ";
            //     }
            //     return price + ",- " + valutaSymbol;
            // }
            
        }
    }

    get_unitTypes(){

        var types = ['°C','J/m³','bar','mbar','m/s','rpm','m³/u','m³','%','uur','A','kW', 'ppm'] ;

        return types ; 

    }

    get_token(){

        return firebase.auth().currentUser.getIdToken(/* forceRefresh */ false).then(function(idToken) {

            return idToken ; 

        }).catch(function(error) {

            store.commit("app/SET_ERROR", error) ;
            return error ; 
  
        });

    }

    get_tagValue(tag, hideUnit){

        if(!tag.value){
            return;
        }

        let value = tag.value ;  
        
        value = value.replace(",", ".") ;

        value = Math.round(value * 100) / 100 ;

        if(!hideUnit && tag.unit){
            return value+" "+tag.unit
        }

        return value ;

    }

    signOut(){

        firebase
        .auth()
        .signOut()
        .then(() => {
            
            // remove local storage companies.
            localStorage.removeItem('currentCompany');

            store.commit("user/SET_USER", { loggedin: false  }) ;
            router.replace({ name: "Login" });

        });
    }

}

export default new helpers();
